import { transformClusters } from './services/normalizer.js';
import { SIGNUP_CLUSTERS_AND_SUBCLUSTERS } from './constants/signup-constants/signup-clusters-and-subclusters-mapper.js';
export { HOMEPAGE_CLUSTERS_DATA } from './constants/homepage-constants/homepage-clusters-data-mapper.js';

const MAPPED_SIGNUP_CLUSTERS_AND_SUBCLUSTERS = transformClusters(SIGNUP_CLUSTERS_AND_SUBCLUSTERS);

export { MAPPED_SIGNUP_CLUSTERS_AND_SUBCLUSTERS };
